<template>
    <div class="user-table-container">
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-select class="Wid120" size="medium" v-model="TypeVal" @change="ReSetPage" clearable placeholder="申请类型">
                    <el-option v-for="i in RowType" :key="i.id" :label="i.group_name" :value="i.id"></el-option>
                </el-select>
                <el-select class="Wid120" size="medium" v-model="SortVal" @change="ReSetPage" clearable placeholder="排序">
                    <el-option label="总分升序" value="1"></el-option>
                    <el-option label="总分降序" value="2"></el-option>
                    <el-option label="平均分升序" value="3"></el-option>
                    <el-option label="平均分降序" value="4"></el-option>
                </el-select>
                <el-select class="Wid120" size="medium" v-model="StateVal" @change="ReSetPage" clearable placeholder="状态">
                    <el-option v-for="item in QueryList.dianping_sq_status" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-input class="Wid120" size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead"></div>
        </div>
        <el-table :data="Data.list" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading">
            <el-table-column prop="record_number" label="编号" min-width="50"></el-table-column>
            <el-table-column prop="record_name" label="标题" min-width="150"></el-table-column>
            <!-- <el-table-column prop="system_sub_id_name" label="所属项目" min-width="80"></el-table-column> -->
            <el-table-column prop="djs" label="点评剩余时间" min-width="80">
                <template slot-scope="scope">
                    <div v-if="scope.row.sq_status==9 && scope.row.djs>0 && scope.row.is_dianping_kai">
                        <Time :seconds="scope.row.djs" @update:seconds="scope.row.djs = $event"/>
                    </div>
                    <div v-if="scope.row.djs<0" class="Red">已超时</div>
                    <div v-if="!scope.row.is_dianping_kai">已暂停</div>
                </template>
            </el-table-column>
            <el-table-column prop="sq_status_name" label="状态" min-width="50">
                <template slot-scope="scope">
                    <el-tag size="small">{{scope.row.sq_status_name}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="120" align="center">
                <template slot-scope="scope">
                    <!-- <el-tooltip effect="dark" content="点评" placement="top-start">
                        <i v-if="scope.row.sq_status ==9" class="NavIcon el-icon-s-claim" @click="ToggleDP(scope.row)"></i> 
                    </el-tooltip>
                    <el-tooltip effect="dark" content="评分明细" placement="top-start">
                        <i class="NavIcon el-icon-tickets" @click="LockPS(scope.row)"></i> 
                    </el-tooltip>
                    <el-tooltip effect="dark" content="查看" placement="top-start">                        
                        <i class="NavIcon el-icon-view" @click="LockDig(scope.row)"></i>                    
                    </el-tooltip>
                    <el-tooltip effect="dark" content="下载" placement="top-start">
                        <!-- <i class="NavIcon el-icon-download" @click="DownFile(scope.row.id)"></i>
                    </el-tooltip> -->
                    <el-button v-if="scope.row.sq_status ==9" v-throttle type="primary" size="mini" @click="ToggleDP(scope.row)">点评</el-button>
                    <el-button v-throttle type="primary" size="mini" @click="LockPS(scope.row,'PS')">评审查看</el-button>
                    <!-- <el-button v-throttle type="primary" size="mini" @click="LockPS(scope.row,'PF')">评分明细</el-button> -->
                    <el-button v-throttle type="primary" size="mini" @click="LockDig(scope.row)">信息查看</el-button>
                    <el-button v-throttle type="primary" size="mini" @click="DownFile(scope.row.id)">下载</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol">
        </el-pagination>
        <FieldMol :visible="NewData.NewBlon" :BaoCun="false" :Type="Type" :rowData="RowData" :newData="NewData" @cancel="$Tools.ResetData(NewData)"/>
        <PingShenInfo :visible="PSBlon" :Type="PSType" :rowData="PSData" @cancel="PSBlon = false" />
        <el-dialog :title="'点评'" :visible.sync="DPData.blon" width="50%" class="BorderRadius">
            <div class="MaxHei">
                <!-- <div class="DigItem">
                    <div class="DigItemWidTit"></div>
                    <div class="Red">{{Data.dianping_ms}}</div>
                </div> -->
                <div class="DigItem">
                    <div class="DigItemWidTit">点评：</div>
                    <el-input class="Wid" size="medium" type="textarea" :rows="2" :placeholder="Data.dianping_ms||'请输入点评'" v-model="DPData.dianping"></el-input>
                </div>
                <div class="DigItem">
                    <div class="DigItemWidTit">附件：</div>
                    <div>
                        <el-upload v-if="!DPData.dianping_url" action="none" :show-file-list="false" :http-request="(res) => UploadFlie(res)">
                            <el-button v-throttle class="BgColor" size="small" type="info">上传</el-button>
                            <span> 文件上传限制500M以内</span>
                        </el-upload>
                        <div v-else>
                            <span>文件</span>
                            <el-tooltip effect="dark" content="查看文件" placement="top-start">
                                <i class="NavIcon el-icon-view" @click="LockUrl(DPData.dianping_url)"></i>
                            </el-tooltip>
                            <el-tooltip effect="dark" content="删除文件" placement="top-start">
                                <i class="NavIcon el-icon-delete" @click="DPData.dianping_url = ''"></i>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(DPData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="SucQRcode">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="签名" :visible.sync="QRcodeBlon" width="20%" :modal-append-to-body="false">
            <div class="QRcodeHead">
                <img class="QRcodeImg" :src="QRcode" alt="" />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-throttle size="small" @click="QRcodeBlon = false">取消签名</el-button>
                <el-button v-throttle size="small" type="primary" @click="DPSuc">我已签名</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "",
        data() {
            return {
                loading:false,
                SearchVal:"",
                TypeVal:"",
                SortVal:"",
                StateVal:"",
                QueryList:"",
                RowType:[],
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
                Type:'Lock',
                NewData:{
                    id:'',
                    NewBlon:false,
                    record_name:"",
                },
                RowData:{//资料数据
                    group: [],
                    gl_file: [],
                },
                PSType:'PS',
                PSData:{},//评审数据
                PSBlon:false,
                DPData:{  //总结数据
                    blon:false,
                    id:"",
                    dianping:"",
                    dianping_url:"",
                },
                QRcodeBlon:false,
                QRcode:""
            };
        },
        props: ['ApiType'],
        mounted() {
            this.GetData();
            this.GetQuery();
            this.GetTypeData();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/api/expert_portal/dianping/list',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                    system_code:this.ApiType,
                    sq_status:this.StateVal,
                    group_id:this.TypeVal,
                    pingfenSort:this.SortVal,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data;
                        this.Totol = res.data.total;
                    }
                })
            },
            GetTypeData(){
                this.$get('/api/expert_portal/info_collection_group',{
                    page:1,
                    page_size:1000,
                    system_code:this.ApiType,
                }).then(res=>{
                    if(res){
                        this.RowType = res.data.list;
                    }
                })
            },
            GetQuery(){
                this.$get('/api/auth/system').then(res=>{
                    if(res){
                        this.QueryList = res.data;
                    }
                })
            },
            GetDetail(id){
                this.$get('/api/expert_portal/dianping/detail',{
                    id:id,
                    system_code:this.ApiType,
                }).then(res=>{
                    if(res){
                        var Data = JSON.parse(JSON.stringify(res.data));
                        Data.group = Data.group.map(item=>{
                            if (item.field_options && typeof item.field_options === 'string') {
                                try {
                                    item.field_options = JSON.parse(item.field_options);
                                    if(item.field_type == 'checkbox'){item.default_value = item.default_value?item.default_value.split(","):[];}
                                } catch (e) {
                                    item.field_options = [];
                                }
                            }
                            return item;
                        })
                        Data.gl_file = Data.gl_file?Data.gl_file.split(","):[];
                        this.RowData = Data;
                    }
                })
            },
            LockPS(row,t){
                this.PSType = t;
                this.$post('/api/expert_portal/dianping/gradeinfo',{
                    id:row.id,
                    ruid:row.ruid,
                }).then(res=>{
                    if(res){
                        this.PSBlon = true;
                        this.PSData = res.data;
                    }
                })
            },
            LockDig(row){
                this.NewData.record_name = row.record_name;
                this.GetDetail(row.id)
                this.NewData.NewBlon = true;
            },
            ToggleDP(row){
                this.GetDetail(row.id)
                this.DPData.id = row.id;
                this.DPData.blon = true;
            },
            SucQRcode(){
                if(!this.DPData.dianping){
                    this.$message.success("请输入点评内容");
                    return;
                }
                this.DPSuc();
                // this.$post("/api/expert_portal/final/fqrcodes", {
                //     "id":this.RowData.id,
                //     "ruid":this.RowData.ruid,
                // }).then(res => {
                //     if (res) {
                //         this.QRcode = res.data.base64;
                //         this.QRcodeBlon = true;
                //     }
                // })
            },
            DPSuc(){
                this.$post("/api/expert_portal/dianping/operation",this.DPData).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData();
                        this.$Tools.ResetData(this.DPData)
                        this.$Tools.ResetData(this.DPData)
                        this.QRcodeBlon = false;
                        this.QRcode = "";
                    }
                })
            },
            UploadFlie(row){
                var file = row.file;
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                const MAX_SIZE = 100 * 1024 * 1024 * 5;
                const fileSize = file.size;
                if (fileSize > MAX_SIZE) {
                    this.$message.error(`文件大小超出限制！最大支持500M，当前文件大小：${(fileSize / 1024 / 1024).toFixed(2)}M`);
                    return;
                }
                try {
                    var fd = new FormData()
                    fd.append('file',file);
                    this.$post("/common/upload/image",fd,{
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }).then((res)=>{
                        loading.close();
                        this.DPData.dianping_url = res.data.url;
                    })
                } catch (error) {
                    loading.close();
                }
            },
            LockUrl(url){
                var str = "";
                if(url.indexOf('http') == 0){
                    str = url;
                }else{
                    str = this.$Tools.ServeUrl()+url;
                }
                window.open(str)
            },
            DownFile(id){
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                try {
                    this.$get('/api/expert_portal/final/export',{
                        id:id,
                    }).then(res=>{
                        loading.close();
                        if(res){
                            window.open(res.data.download_url)
                        }
                    })
                } catch (error) {
                    loading.close();
                }
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    .MaxHei{
        max-height: 500px;
        overflow-y: auto;
    }
    .DisFlex{
        display: flex;
        align-items: center;
    }
    .FuJianPos{
        position: relative;
        padding: 6px 10px;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;
    }
    .FuJianAbs{
        position: absolute;
        top: -5px;
        right: -15px;
        font-size: 14px;
        color: #d51938;
    }
    .TableBg{
        background: #dcdcdc;
    }
    .TablePad{
        padding: 10px 0;
        font-weight: 700;
    }
    .Wid30{
        width: 35%;
    }
    .Wid70{
        width: 65%;
    }
    .TableNum{
        padding-bottom: 10px;
        font-weight: 700;
    }
    .DigTable{
        border: 1px solid #028b8b;
        margin-bottom: 10px;
    }
    .DigTableTop{
        display: flex;
        border-bottom: 1px solid #028b8b;
    }
    .DigTableHead{
        border-bottom: 1px solid #028b8b;
    }
    .DigTableDis{
        display: flex;
    }
    .DPMsg{
        text-align: center;
        padding-bottom: 5px;
    }
    .ItemDis{
        display: flex;
        align-items: center;
    }
    .DigTableBor{
        text-align: center;
        border-right: 1px solid #028b8b;
    }
    .DigTableBor:last-child{
        border: 0;
    }
    .ItemTit{
        width: 130px;
        font-weight: 500;
        font-size: 18px;
        padding: 5px;
    }
    .ItemFuTit{
        flex: 1;
        padding: 5px;
        border-left: 1px solid #028b8b;
        text-align: center;
    }
    .ItemQz{
        padding-top: 5px;
    }
    .ItemRadio{
        height: 50%;
    }
    .ItemRadio .Radio{
        height: 100%;
        display: inline-block;
        position: relative;
    }
    .RadioCer{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
    }
    .RadioCer input{
        margin-top: 0;
    }
    .RadioCer span{
        font-size: 12px;
    }
    .ItemRadio .Radio::after{
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        height: 100%;
        border-right: 1px solid #028b8b;
    }
    .ItemRadioMsg{
        height: 50%;
        border-top: 1px solid #028b8b;
    }
    .ItemRadioMsg .ItemRadioMsgDom{
        height: 100%;
        display: inline-block;
        position: relative;
    }
    .ItemRadioMsg .ItemRadioMsgDom::after{
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        height: 100%;
        border-right: 1px solid #028b8b;
    }
    .ItemMsg{
        padding: 5px;
        border-top: 1px solid #028b8b;
    }
    .ItemRadio .Radio:last-child::after,
    .ItemRadioMsg .ItemRadioMsgDom:last-child::after,
    .DigTableHead:last-child{
        border: 0;
    }
    .QRcodeHead{
        text-align: center;
    }
    .QRcodeImg{
        width: 200px;
        height: 200px;
        border-radius: 5px;
    }
</style>
